<template>
    <div class="yimiao">
        <div>
            <div>
                <!-- 标题信息 -->
                <van-cell-group>
                    <van-field v-model="datafrom1.name" label="姓名" required placeholder="请输入姓名" />
                </van-cell-group>
                <van-cell-group>
                  <van-field v-model="datafrom1.gender" required @click="Rentalmethod = true" readonly="readonly" label="性别"
                    placeholder="请选择性别" />
                    <van-popup v-model="Rentalmethod" position="bottom" get-container="body">
                      <van-picker show-toolbar :columns=columns @cancel="Rentalmethod = false" @confirm="finised">
                      </van-picker>
                  </van-popup>
                </van-cell-group>

                <van-cell-group>
                    <van-field v-model="datafrom1.phone" label="联系电话" required placeholder="请输入联系电话" />
                </van-cell-group>
                <van-cell-group>
                    <van-field v-model="datafrom1.idCard" required label="身份证" placeholder="请输入身份证" />
                </van-cell-group>
               

            </div>
            <!-- <div class="buttons">
              <van-button type="info" @click="postfrom()">提交</van-button>
            </div> -->

            <div class="buttons">
                <van-button type="info" style="margin: 10px 0" v-if="bangdingShow" @click="postfrom()">提交</van-button>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript" src="//api.map.baidu.com/api?v=3.0&ak=L2s5R0CE405alnjKlsp35mNTySNAvZtd"></script>
    <script>
    import Vue from 'vue'
    import { Dialog } from 'vant'
    import { Toast } from 'vant'
    import { setOpenId, getOpenId } from '@/utils/auth'
    import config from '@/config'
    import Compressor from 'compressorjs'
    import axios from 'axios'
    import { loadBMap } from '../fangyi/baiduLocation.js'
    import { WxGetShopTypeList, WxGetNeInfoPage } from '@/api/shop'
    import { WxGetFnRoom } from '@/api/yeguang'
    import {putQuestionnaire} from '@/api/Questionnaire'
    Vue.use(Toast)
    export default {
     
      data() {
        return {
          columns:[  "男","女"],
          datafrom: {
            name:'',
            phone:'',
            idCard:'',
            OpenID: '',
            LeaseId: 0, //id、
            RoomSource: '', // 名称、
            OrgCode: '',
            Remark: '',
            Imgs: '',
            LeaseMode: '', //出租方式id
            Area: '', //房屋面积
            RoomType: '', //房屋类型
            Floor: '', //房屋楼层
            Toward: '', //房屋朝向
            Price: '', //房子租金
            Deposit: '', //房屋押金
            OpenHome: '', //看房时间
            InRequire: '', //入住要求
            Describe: '', //房源描述
            Address: '',
            Coordinate: '', // 地图坐标
            TouchMan: '', // 联系人、
            TouchTel: '', // 手机、
            Status: '1',
            Remark: '', // 备注
            // 新增的字段
            content:'',//富文本内容
            title:'',//标题
            typeName:'',//出租分类方式
            typeId:''
          },
          datafrom1:{
            name:'',
            phone:'',
            idCard:'',
            gender:''
          },
          TouchTel: '',
          shopType: [],
          shopType1: [],
          shopLevel: [
            { name: '一星', val: 1 },
            { name: '二星', val: 2 },
            { name: '三星', val: 3 },
            { name: '四星', val: 4 },
            { name: '五星', val: 5 },
          ],
          WorkTime: [],
          shopTypePicker: false, //商铺类型
          shopTypePicker1: false, //商铺等级
          shopTypePicker2: false, //邻里中心
          idListRId: false,
          idListOrg: false,
          Rentalmethod: false,
          addshow: false,
          verifyshow: true,
          OCodeshow: false,
          OLeaseMode: false,
          sexshow: false,
          Nationshow: false,
          yimiao: false,
          datafromBackTime: false,
          datafromOutTime: false,
          dWshow: false,
          bangdingShow: true,
          bjZuoBiao: '',
          shopAdd: this.$route.query.add,
          cascaderValues: '',
        }
      },
      created() {
        this.GetOrgansNullToken()
        this.shopXq()
        this.zidianlist()
        this.zidianlist1()
        this.ShopCate = this.$route.query.shopCate
        this.getAllType()
        
      },
      mounted(){
        this.getType()
      },
    
      methods: {
        getType(){
          this.datafrom1.type = this.$route.params.id
          console.log(this.datafrom1);
        },
        finised(val){
          this.datafrom1.gender = val
          this.Rentalmethod = false
          console.log(val);
        },
        // 获取所有出租分类方式
        getAllType(){
          listType().then((res)=>{
            this.Rentalname = res.data.data
          })
        },
        // 社区搜索
        onFinish({ selectedOptions }) {
          // console.log(val, 'val')
    
          const fieldValue = selectedOptions.map((option) => option.OrganName).join('/')
          this.datafrom.OrgName = fieldValue
          this.datafrom.OrgCode = selectedOptions[selectedOptions.length - 1].OrganCode
    
          this.cascaderValues = this.datafrom.OrgCode
    
          // this.datafrom.OrgCode = val.organcode
          // this.datafrom.OrgName = val.organname
          this.idListOrg = false
        },
        onstartTimeShow(val) {
          this.WorkTime[0] = val
          this.startTimeShow = false
        },
        onendTimeShow(val) {
          this.WorkTime[1] = val
          this.endTimeShow = false
        },
        onInput(event) {
          this.setData({
            currentDate: event.detail,
          })
        },
        shopXq: function() {
          console.log(this.$route.query)
          if (this.$route.query.add == '1') {
            this.datafrom = {
              OpenID: '',
              LeaseId: 0, //id、
              RoomSource: '', // 名称、
              OrgCode: '',
              Remark: '',
              Imgs: '',
              LeaseMode: '', //出租方式id
              Area: '', //房屋面积
              RoomType: '', //房屋类型
              Floor: '', //房屋楼层
              Toward: '', //房屋朝向
              Price: '', //房子租金
              Deposit: '', //房屋押金
              OpenHome: '', //看房时间
              InRequire: '', //入住要求
              Describe: '', //房源描述
              Address: '',
              Coordinate: '', // 地图坐标
              TouchMan: '', // 联系人、
              TouchTel: '', // 手机、
              Status: '1',
              Remark: '', // 备注
              // 新增字段
              content:'',//内容
              title:'',//标题
            }
          } else if (this.$route.query.add == '2' || this.$route.query.add == '3') {
            WxGetLease(this.$route.query.LeaseId).then((res) => {
              this.bangdingShow = true
              if (res.data.code == 0) {
                this.datafrom = res.data.data
                console.log(res.data.data, '000000000')
                //重点监控
                this.bjZuoBiao = res.data.data.Coordinate
                // this.WorkTime[0] = res.data.data.WorkTime.split("-")[0];
                // this.WorkTime[1] = res.data.data.WorkTime.split("-")[1];
                // this.datafrom.IsMonitor = res.data.data.IsMonitor + "";
                this.datafrom.Status = res.data.data.Status + ''
                this.datafrom.OrgCode = res.data.data.OrgCode
                this.datafrom.OrgName = res.data.data.OrgName
                // this.datafrom.Region = res.data.data.RName;
                this.datafrom.STypeId = res.data.data.STypeId
                this.datafrom.STypeDesc = res.data.data.STypeDesc
                if (res.data.data.LeaseMode == 1) {
                  this.datafrom.LeaseModeDesc = '整租'
                } else if (res.data.data.LeaseMode == 2) {
                  this.datafrom.LeaseModeDesc = '合租'
                }
                // this.RegionList(res.data.data.OCode)
                console.log(res.data.data)
                //商铺照片
                if (res.data.data.Logo != '') {
                  this.ShopImgLists = [res.data.data.Logo]
                  var arr = []
                  this.ShopImgLists.forEach(function(imgUrl) {
                    arr.push({ url: imgUrl })
                  })
                  this.ShopImgList = arr
                  this.datafrom.Logo = res.data.data.Logo
                }
                if (res.data.data.Imgs != '') {
                  //营业执照
                  this.jkImageLists = [res.data.data.Imgs]
                  var arrYe = []
                  this.jkImageLists.forEach(function(imgUrl) {
                    arrYe.push({ url: imgUrl })
                  })
                  this.jkImageList = arrYe
                  this.datafrom.Imgs = res.data.data.Imgs
                }
                // this.datafrom.ShopTypeKind = res.data.data.ShopTypeKind;
                // this.datafrom.STypeDesc = res.data.data.ShopTypeDesc;
                // this.datafrom.Region = res.data.data.RName;
                // this.datafrom.IsMonitor = res.data.data.IsMonitor;
              }
              if (this.$route.query.add == '3') {
                this.bangdingShow = false
              }
            })
          }
        },
        dwXuanze: function(row) {
          if (row == '1') {
            this.dingwei()
            this.dWshow = true
          } else {
            this.dWshow = false
            this.Coordinate = this.bjZuoBiao
          }
        },
        dingwei: function() {
          var that = this
          // 百度地图API功能
          window.initBaiduMapScript = () => {
            that.BMap = window.BMap
            var map = new window.BMap.Map('allmap')
            var point = new that.BMap.Point(116.331398, 39.897445)
            map.centerAndZoom(point, 18)
    
            var geolocation = new that.BMap.Geolocation()
            var Coordinate = ''
            geolocation.getCurrentPosition(
              function(r) {
                if (this.getStatus() == BMAP_STATUS_SUCCESS) {
                  var mk = new BMap.Marker(r.point)
                  map.addOverlay(mk)
                  map.panTo(r.point)
                  this.Coordinate = [{ lng: r.point.lng, lat: r.point.lat, of: 'inner' }]
                  console.log(this.Coordinate,"CoordinateCoordinateCoordinate")
                  that.dingweiList(this.Coordinate)
                  // alert('您的位置：' + r.point.lng + ',' + r.point.lat);
                } else {
                  alert('failed' + this.getStatus())
                }
              },
              { enableHighAccuracy: true }
            )
            console.log(geolocation)
            this.dingweiList(geolocation)
          }
          loadBMap('initBaiduMapScript')
        },
        dingweiList: function(geolocation) {
          console.log(geolocation)
          this.Coordinate = geolocation
        },
        // 字典查询
        zidianlist: function() {
          // 商铺类型
          WxGetShopTypeList({ shopCate: 2 }).then((res) => {
            if (res.data.code == '0') {
              this.shopType = res.data.data
              console.log(this.shopType, ' this.shopType ')
            }
          })
          // GetCodeEntrysList({ kind: "310" }).then((res) => {
          //   this.shopType = res.data.data;
          // });
        },
        // 字典查询
        zidianlist1: function() {
          // 邻里中心
          WxGetNeInfoPage({ openID: getOpenId() }).then((res) => {
            console.log(getOpenId(), '111')
            if (res.data.code == '0') {
              this.shopType1 = res.data.data
              console.log(this.shopType1, ' this.shopType12 ')
            }
          })
          // GetCodeEntrysList({ kind: "310" }).then((res) => {
          //   this.shopType = res.data.data;
          // });
        },
        // 确认商铺类型
        shopTypeQr(val) {
          this.datafrom.STypeId = val.STypeId
          this.datafrom.STypeDesc = val.Name
          this.shopTypePicker = false
        },
        // 确认商铺等级
        shopTypeQr1(val) {
          console.log(val, '选中等级')
          this.datafrom.Level = val.val
          this.datafrom.LevelDesc = val.name
          this.shopTypePicker1 = false
        },
        // 确认商铺等级
        shopTypeQr3(val) {
          console.log(val, '选中邻里中心')
          this.datafrom.NeInfoId = val.InfoId
          this.datafrom.NeInfoName = val.Name
          this.shopTypePicker2 = false
        },
        //上传营业执照
        afterRead(file) {
          var that = this
          file.status = 'uploading'
          file.message = '上传中...'
          new Compressor(file.file, {
            quality: 0.5,
            success(result) {
              var formData = new FormData()
              let c = {
                headers: { 'Content-Type': 'multipart/form-data' },
              }
              //构造一个 FormData，把后台需要发送的参数添加
              formData.append('file', result, result.name)
              axios.post(config.apiUploadUrl, formData, c).then((res) => {
                if (res.data.code === 0) {
                  console.log(res.data.msg)
                  that.datafrom.Imgs = res.data.msg
                  // that.datafrom.EvalImgs.push(res.data.data);
                  file.status = ''
                  file.message = ''
                } else {
                  Toast.fail(res.data.msg)
                }
              })
            },
          })
        },
        //删除营业执照
        jkDelete(file) {
          this.jkImageList = []
          this.datafrom.Imgs = ''
        },
        //上传商铺图片
        ShopImgRead(file) {
          var that = this
          file.status = 'uploading'
          file.message = '上传中...'
          new Compressor(file.file, {
            quality: 0.5,
            success(result) {
              var formData = new FormData()
              let c = {
                headers: { 'Content-Type': 'multipart/form-data' },
              }
              //构造一个 FormData，把后台需要发送的参数添加
              formData.append('file', result, result.name)
              axios.post(config.apiUploadUrl, formData, c).then((res) => {
                if (res.data.code === 0) {
                  console.log(res.data.picurl)
                  that.datafrom.Logo = res.data.picurl[0]
                  // that.datafrom.EvalImgs.push(res.data.data);
                  file.status = ''
                  file.message = ''
                } else {
                  Toast.fail(res.data.msg)
                }
              })
            },
          })
        },
        //删除商铺图片
        xcDelete(file) {
          this.ShopImgList = []
          this.datafrom.Logo = ''
        },
        //上传核酸证明
        afterhsRead(file) {
          var that = this
          file.status = 'uploading'
          file.message = '上传中...'
          new Compressor(file.file, {
            quality: 0.5,
            success(result) {
              var formData = new FormData()
              let c = {
                headers: { 'Content-Type': 'multipart/form-data' },
              }
              //构造一个 FormData，把后台需要发送的参数添加
              formData.append('file', result, result.name)
              axios.post(config.apiUploadUrl, formData, c).then((res) => {
                if (res.data.code === 0) {
                  console.log(res.data.data)
                  that.datafrom.Testify = res.data.data
                  // that.datafrom.EvalImgs.push(res.data.data);
                  file.status = ''
                  file.message = ''
                } else {
                  Toast.fail(res.data.msg)
                }
              })
            },
          })
        },
        //删除核酸
        hsDelete(file) {
          this.hsImageList = []
          this.datafrom.Testify = ''
        },
        // 提交
        postfrom: function() {
            this.getType()
            console.log(this.datafrom1.name);
            if (this.datafrom1.name == '') {
              Toast.fail('请输入姓名')
              return false
            }
            if(this.datafrom1.gender ==''){
              Toast.fail('请选择性别')
              return false
            }
            if (this.datafrom1.phone == '') {
              Toast.fail('请输入联系电话')
              return false
            }
            if (this.datafrom1.idCard == '') {
              Toast.fail('请输入身份证号')
              return false
            }
            putQuestionnaire(this.datafrom1).then((res)=>{
               if(res.data.code==0){
                Toast('提交成功')
                this.datafrom1.name=''
                this.datafrom1.phone=''
                this.datafrom1.idCard=''
                this.datafrom1.gender=''
               }else{
                Toast.fail('提交失败')
               }
            })
        
        
        },
        gitocodelist() {
          GetOrgansNullToken().then((res) => {
            this.ocodelist = res.data.data
          })
        },
        // 社区列表
        GetOrgansNullToken: function(row) {
          GetOrgansNullToken({ level: 4, kind: 1 }).then((res) => {
            this.OrganList = res.data.data
          })
        },
        // 小区(组)列表
        RegionList: function(row) {
          WeGetRegionList({ organCode: row }).then((res) => {
            this.ridlist = res.data.data
          })
        },
        // 房屋列表
        BuildRoomList: function(val) {
          WeGetBuildRoomList({
            bId: this.idList.BId,
            buId: this.idList.buId,
            bfId: val,
          }).then((res) => {
            console.log(res)
            this.BRIdlist = res.data.data
          })
        },
        fanhui: function() {
          this.$router.go(-1)
        },
        // 社区选择器
        onidListOrg(val) {
          console.log(this.datafrom, '0523')
          this.datafrom.OrgCode = val.organcode
    
          this.datafrom.OrgName = val.organname
          console.log(val, '987654321')
          this.idListOrg = false
          this.RegionList(val.organcode)
          console.log(this.OrganList)
          // this.datafrom.Region = "";
          // this.BuildList(val.RId);
        },
        //出租方式
        onidRenta(val,id) {
          console.log(val,id);
          this.datafrom.typeName = val
          this.datafrom.typeId = this.Rentalname[id].id
          console.log( this.datafrom.typeId);
          // this.datafrom.typeId = id
          this.Rentalmethod = false
          // this.RentalId = this.Rentalname.find((item) => item.name == val)
          // this.datafrom.LeaseMode = this.RentalId.id
          // console.log(this.datafrom, '6010')
        },
    
        // 小区(组)选择器
        onidListRId(val) {
          this.datafrom.RId = val.RId
          // this.datafrom.Region = val.Title;
          this.idListRId = false
          this.BuildList(val.RId)
        },
        // 性别选择器
        onsexshow(val) {
          this.datafrom.sex = val.id
          this.datafrom.sexName = val.Name
          this.sexshow = false
        },
    
        // 消防器材年检日期
        ondatafromOutTime(val) {
          this.datafrom.YearCheckTime = this.dateformat(val)
          this.datafromOutTime = false
        },
        // 社区
        onocode(val) {
          this.datafrom.OrgName = val.selectedOptions[0].OrganName
          this.RegionList(val.value)
          this.OCodeshow = false
        },
        dateformat(val) {
          // 时间格式化事件 yy-mm-dd
          // let year = val.getFullYear();
          // let month = val.getMonth() + 1;
          // let day = val.getDate();
          let houser = val.getHours()
          let Minutes = val.getMinutes()
          if (month >= 1 && month <= 9) {
            month = `0${month}`
          }
          if (day >= 1 && day <= 9) {
            day = `0${day}`
          }
          if (houser >= 1 && houser <= 9) {
            houser = `0${houser}`
          }
          if (Minutes >= 1 && Minutes <= 9) {
            Minutes = `0${Minutes}`
          }
          // return `${year}-${month}-${day} ${houser}:${Minutes}`;
          return `${year}-${month}-${day}`
        },
      },
      
    }
    </script>
<style>
.imgs {
    margin: 0 15px;
}

.yimiao .inputFrom {
    margin: 15px 8%;
}

.yimiao .inputFrom input {
    width: 80%;
    margin: 8px 8%;
    padding: 8px 5px;
    font-size: 14px;
    border: 1px solid #e6e6e6;
}

.yimiao .buttons {
    text-align: center;
}

.yimiao .buttons button {
    width: 90%;
    margin: 25px 5%;
    border-radius: 10px;
}

.buttons {
    text-align: center;
}

.buttons button {
    margin: 25px 10px;
    border-radius: 10px;
}
</style>
    